var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCaretDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.392 6.8955C11.4159 6.87138 11.4231 6.83522 11.41 6.8038C11.3971 6.77241 11.3665 6.75189 11.3326 6.75171L4.66778 6.75171C4.63383 6.75189 4.60329 6.77241 4.5903 6.8038C4.5773 6.8352 4.58443 6.87133 4.60835 6.89545C4.6083 6.8954 4.60841 6.89551 4.60835 6.89545L7.94061 10.2287C7.94054 10.2286 7.94067 10.2288 7.94061 10.2287C7.97348 10.2613 8.02667 10.2615 8.05955 10.2289C8.05961 10.2288 8.05948 10.229 8.05955 10.2289L11.392 6.8955C11.3919 6.89554 11.392 6.89545 11.392 6.8955ZM12.796 6.23013C13.0408 6.82143 12.9057 7.50191 12.4538 7.95498L9.1191 11.2907C8.50069 11.9076 7.49966 11.9076 6.88125 11.2907L3.54713 7.95555C3.09517 7.50248 2.95959 6.82143 3.20434 6.23013C3.44909 5.63882 4.02553 5.25282 4.66548 5.25171L11.3349 5.25171C11.9748 5.25282 12.5513 5.63882 12.796 6.23013Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaretDown);
export default __webpack_public_path__ + "static/media/icon-caret-down.962657a377151bcaebee8696cf5ef5d0.svg";
export { ForwardRef as ReactComponent };